export default __webpack_public_path__ + "static/media/Atticus-A.7ab49b96.svg";